import { GGU_ORIENTATION_LINK } from '../Constants'
import { isOrientationChapter } from './chapterUtils'

export const getOrientationUrl = ({ courseChapters, isGGUCohort, profCert }) => {
  if (profCert) {
    const orientationChapter = courseChapters?.find(chapter =>
      isOrientationChapter(chapter)
    )?.sections[0]
    const { section_uuid: orientationChapterUUID } = orientationChapter || {}
    return `#/${orientationChapterUUID}`
  }

  if (isGGUCohort) {
    return GGU_ORIENTATION_LINK
  }

  return '#/resources/orientation'
}
